<app-nav-bar></app-nav-bar>

<!-- Hero Section -->
<section class="hero-section">
    <div class="container-fluid hero-content">
        <div class="row align-items-center min-vh-100">
            <div class="col-lg-6 hero-text">
                <h1 class="hero-title">Fair. Transparent. Real-Time.</h1>
                <p class="hero-subtitle">Automate your sales rotation across every customer channel</p>
                <p class="hero-description">UpBoards is the intelligent lead rotation system that ensures every salesperson gets equal opportunities for walk-in customers.</p>
                <div class="hero-cta">
                    <a href="/signin" class="btn btn-primary btn-lg">Sign In to View Your Boards</a>
                </div>
                <div class="hero-stats">
                    <div class="stat">
                        <h3>Real-Time</h3>
                        <p>Updates instantly across all channels</p>
                    </div>
                    <div class="stat">
                        <h3>Fair Rotation</h3>
                        <p>Every salesperson gets equal opportunities</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 hero-visual">
                <div class="hero-board-demo">
                    <div class="demo-tables-container">
                        <!-- Available Column -->
                        <div class="demo-table-column">
                            <table class="demo-table">
                                <thead>
                                    <th>Available</th>
                                </thead>
                                <tr>
                                    <td class="col-primary">
                                        <div class="demo-employee up">
                                            <span class="demo-employee-badge">1</span>
                                            <b>John Smith</b>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-primary">
                                        <div class="demo-employee on-deck">
                                            <span class="demo-employee-badge">2</span>
                                            <b>Alex Kim</b>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="col-primary">
                                        <div class="demo-employee">
                                            <span class="demo-employee-badge">3</span>
                                            <b>Mike Davis</b>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <!-- Appointment Column -->
                        <div class="demo-table-column">
                            <table class="demo-table">
                                <thead>
                                    <th>Appointment</th>
                                </thead>
                                <tr>
                                    <td class="col-primary">
                                        <div class="demo-employee">
                                            <span class="demo-employee-badge">2</span>
                                            <b>Lisa Brown</b>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <!-- With Guest Column -->
                        <div class="demo-table-column">
                            <table class="demo-table">
                                <thead>
                                    <th>With Guest</th>
                                </thead>
                                <tr>
                                    <td class="col-primary">
                                        <div class="demo-employee">
                                            <b>Tom Wilson</b>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <!-- Break Column -->
                        <div class="demo-table-column">
                            <table class="demo-table">
                                <thead>
                                    <th>Break</th>
                                </thead>
                                <tr>
                                    <td class="col-alternate">
                                        <div class="demo-employee">
                                            <span class="demo-employee-badge">4</span>
                                            <b>Emma Davis</b>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
